import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import './CaseBasicInformation.scss'
import CaseTitle from './CaseTitle';
import CaseInfo from './CaseInfo';

const CaseBasicInformation = (props) => {    

    const lang = useSelector(state => state.layout.lang)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <Fragment>
            <CaseTitle loading={!props.oteCase}
                descEn={props.oteCase ? props.oteCase.return_details.description_en.title : null}
                descFr={props.oteCase ? props.oteCase.return_details.description_fr.title : null}
                lang={lang} />
            <CaseInfo oteCase={props.oteCase} lang={lang}/>
        </Fragment>
    );
}

CaseBasicInformation.propTypes = {
    oteCase: PropTypes.object
}
CaseBasicInformation.whyDidYouRender = false;

export default CaseBasicInformation